module.exports = __webpack_public_path__ + "static/media/spinner.eb6b33a3.svg";